import React from 'react'
import { Spinner } from '@notino/react-styleguide'

// styles
import * as SC from './LoadingStyles'

type Props = {
	maxHeight?: string
	maxWidth?: string
	padding?: string
	className?: string
}

const Loading = (props: Props) => {
	const { maxHeight = '300px', maxWidth = '400px', padding, className } = props

	return (
		<SC.LoadingWrapper $maxWidth={maxWidth} $maxHeight={maxHeight} $padding={padding} className={className}>
			<Spinner color={'icon.primary'} size={40} />
		</SC.LoadingWrapper>
	)
}

export default Loading
